// @ts-nocheck
import * as React from "react";

const QuickOrderFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <g fill="none" fillRule="evenodd">
                <path
                    fill="currentColor"
                    d="m1 9.36 8.25 3.47V22h-.06L2 18.61a1.69 1.69 0 0 1-1-1.52V9.36ZM17.5 13c.51 0 1.013-.06 1.5-.176V17.1a1.69 1.69 0 0 1-1 1.51L10.8 22h-.05v-9.17l2.792-1.174A6.5 6.5 0 0 0 17.5 13Zm-6.7-8.82.538.252a6.498 6.498 0 0 0 1.04 6.07L10 11.5 1.49 7.93A1.62 1.62 0 0 1 2 7.55l7.2-3.37a1.87 1.87 0 0 1 1.6 0ZM17.5 1.5a5 5 0 1 0 5 5 5 5 0 0 0-5-5Zm2 5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 1 1 1 0V6h1.5a.5.5 0 1 1 0 1Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(QuickOrderFill);
